import api from './api';

const unwrap = (response) => {
  if (response?.data?.data !== undefined) return response.data.data;
  return response?.data ?? response;
};

const escrowService = {
  getUserEscrows: async (role = 'all') => {
    const response = await api.get('/escrow/user/accounts', { params: { role } });
    return unwrap(response);
  },

  getEscrowDetails: async (escrowId) => {
    const response = await api.get(`/escrow/${escrowId}`);
    return unwrap(response);
  },

  createEscrowAccount: async (payload) => {
    const response = await api.post('/escrow/create', payload);
    return unwrap(response);
  },

  fundEscrowAccount: async (escrowId, payload) => {
    const response = await api.post(`/escrow/${escrowId}/fund`, payload);
    return unwrap(response);
  },

  confirmStripeCheckout: async (sessionId) => {
    const response = await api.post('/escrow/stripe-checkout/confirm', { sessionId });
    return unwrap(response);
  },

  submitMilestone: async (milestoneId, payload) => {
    const response = await api.post(`/escrow/milestone/${milestoneId}/submit`, payload);
    return unwrap(response);
  },

  approveMilestone: async (milestoneId) => {
    const response = await api.post(`/escrow/milestone/${milestoneId}/approve`);
    return unwrap(response);
  },

  raiseDispute: async (escrowId, payload) => {
    const response = await api.post(`/escrow/${escrowId}/dispute`, payload);
    return unwrap(response);
  },

  requestRefund: async (escrowId, reason) => {
    const response = await api.post(`/escrow/${escrowId}/refund-request`, { reason });
    return unwrap(response);
  },

  getMyRefundRequests: async () => {
    const response = await api.get('/escrow/my-refund-requests');
    return unwrap(response);
  },

  // Admin
  getRefundRequests: async (status = 'pending') => {
    const response = await api.get('/escrow/refund-requests', { params: { status } });
    return unwrap(response);
  },

  approveRefund: async (transactionId) => {
    const response = await api.post(`/escrow/refund-requests/${transactionId}/approve`);
    return unwrap(response);
  },

  denyRefund: async (transactionId, reason) => {
    const response = await api.post(`/escrow/refund-requests/${transactionId}/deny`, { reason });
    return unwrap(response);
  },

  getPaymentGateways: async (query = {}) => {
    const response = await api.get('/escrow/payment/gateways', { params: query });
    return unwrap(response);
  },

  getTransactionStatus: async (transactionId) => {
    const response = await api.get(`/escrow/transaction/${transactionId}/status`);
    return unwrap(response);
  },

  estimateTransferTime: async (gateway, params = {}) => {
    const response = await api.get(`/escrow/payment/estimate/${gateway}`, { params });
    return unwrap(response);
  }
};

export default escrowService;
